import {
  PartnersPersonalizationEngineRequest,
  PartnersPersonalizationEngineResponse
} from '../models/partners-personalization-engine.interfaces';
import { CustomErrorVariant } from '@com-delta-idp/mnx-utils';

export const PartnersPersonalizationRequestMocks: PartnersPersonalizationEngineRequest =
  {
    userdata: {
      membershipLevel: 'DM'
    },
    requestparam: {
      campaignId: 'ng-skymiles:partners-v1',
      format: 'json'
    }
  };

export const PartnersPersonalizationResponseMocks: PartnersPersonalizationEngineResponse =
  {
    format: 'json',
    finalcontentPath:
      '/content/www/en_US/personalization/campaign/ng-skymiles/partners/existing-member',
    contentDetails: {
      'jcr:description': ['', ''],
      minimumStay: '1',
      'cq:segments': [
        '/etc/segmentation/delta/ng-skymiles/partners/new-member'
      ],
      skyMilesTier: 'default',
      analyticsPageName:
        'en_US:personalization:campaign:ng skymiles:partners:new member',
      alertLevel: 'other',
      parsys: {
        partners: {
          viewAllPartnersId: 'viewAllPartners',
          viewAllPartnersLabel: 'View All Partners',
          sectionTitle: 'Earn With Our Partners',
          partners: [
            '{"id":"earnMilesWithEveryLyft","logo":"/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/lyft-logo.svg","logoAltText":"Lyft Logo","title":"Earn Miles With Every Lyft","ctaLabel":"Link Account","ctaURL":"https://www.deltalyft.com", "promoCode":"lyft"}',
            '{"id":"earnMilesWithStarbucks","logo":"/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/starbucks-logo.svg","logoAltText":"Starbucks Logo","title":"Earn Miles With Starbucks","ctaLabel":"Link Account","ctaURL":"https://www.deltalyft.com/", "promoCode":"star"}',
            '{"id":"earnMileWithAirbnb","logo":"/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/airbnb-logo.svg","logoAltText":"Airbnb Logo","title":"Earn 1 Mile per $1 spent with Airbnb","ctaLabel":"Book Now","ctaURL":"https://www.deltaairbnb.com", "promoCode":"bnb"}',
            '{"id":"earnMilesWithEveryOrder","logo":"/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/instacart-logo.svg","logoAltText":"Instacart Logo","title":"Earn Miles With Every Order","ctaLabel":"Link Account","ctaURL":"https://www.delta.com/instacart", "promoCode":"turo"}'
          ],
          viewAllPartnersCTA: '/mypromos/eligible'
        }
      },
      teaserCampaign: []
    }
  };

export const PartnersPersonalizationErrorResponseMocks: CustomErrorVariant = {
  format: 'json',
  error: {
    errorCode: '111',
    errorMessage: 'Please try again later'
  }
};
